module.exports = __webpack_public_path__ + "img/cnn.b0bcec89.svg";